module.exports = __webpack_public_path__ + "static/img/whatsapp.188a278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp.png
// module id = s1Vd
// module chunks = 0